import { toast } from 'sonner'

/**
 * Helper function to validate Formik form before showing confirmation dialog
 * @param {Object} validation - Formik validation object
 * @returns {Promise<boolean>} - Returns true if validation passes, false if errors exist
 */
export const validateBeforeConfirm = async (validation) => {
    // Trigger validation and update form state
    const errors = await validation.validateForm(validation.values)
    validation.setErrors(errors)

    // Mark all fields as touched to show validation errors
    const touchedFields = {}
    Object.keys(validation.values).forEach(key => {
        touchedFields[key] = true
    })
    validation.setTouched(touchedFields)

    // Check if there are any existing toasts and dismiss them first
    const existingToasts = document.querySelectorAll('[data-sonner-toast]')
    if (existingToasts.length > 0) {
        toast.dismiss()
    }

    // Show validation error toast if there are errors
    if (Object.keys(errors).length > 0) {
        // Show the first error only (since we only want one toast at a time)
        const firstErrorKey = Object.keys(errors)[0]
        const firstErrorValue = errors[firstErrorKey]

        let errorMessage

        if (typeof firstErrorValue === 'string') {
            errorMessage = firstErrorValue
        } else if (typeof firstErrorValue === 'object' && firstErrorValue !== null) {
            const nestedErrors = Object.values(firstErrorValue).filter(Boolean)
            errorMessage = nestedErrors[0] || 'Validation error'
        } else {
            errorMessage = 'Validation error'
        }

        toast.error(`${firstErrorKey.charAt(0).toUpperCase() + firstErrorKey.slice(1)}: ${errorMessage}`)
    }
    // Return true if no errors, false if errors exist
    return Object.keys(errors).length === 0
}